import { makePostWithoutToken } from './ServiceManager';

export const generateScreenshotsForAd = async (ads) => {
  const result = await makePostWithoutToken('image/allads', { ads });
  return result;
};



// WEBPACK FOOTER //
// ./src/services/ScreenshotManager.js